const googleApiKeys = {
  development: 'AIzaSyAVGp2yFf4ay6vwoba7oJ8zRxpjghsrK3U',
  production: 'AIzaSyCig9gelk_UFz3SzzdOy6vMJ9aOyHTIFrg'
}

const getGoogleApiKey = (environment = 'production') => {
  return googleApiKeys[environment] || googleApiKeys.production
}

export { getGoogleApiKey }



// WEBPACK FOOTER //
// ./src/helpers/apiKeyHelpers.js